import s from './Divider.module.scss'

const Divider = ({noMarginTop = 'false', noMarginBottom = 'false', noLine = 'false'}) => {
    return <hr className={`${!!noMarginTop && noMarginTop == 'true' ? s.mt0 : s.mt40px} ${!!noMarginBottom && noMarginBottom == 'true' ? s.mb0 : s.mb40px} ${!!noLine && noLine == 'true' ? s.opacity0 : ""}`} />
}

export default Divider